export default __webpack_public_path__ + "static/media/misc-books5-1440w.aa3d44ea.avif";